import React from 'react';
import Button from '../common/Button';

const QualificationsTab = ({
    qualifications,
    addItem,
    editIndex,
    editItem,
    loading,
    onAddChange,
    onEditChange,
    onCancelAdd,
    onCancelEdit,
    onEdit,
    onAddQualification,
    onUpdateQualification,
    onDeleteQualification,
    setAddItem
}) => {
    return (
        <div>
            <div className="flex justify-between items-center mb-3">
                <h3 className="text-lg font-semibold text-gray-900">Qualifications</h3>
                {addItem.qualifications ? (
                    <div className="flex gap-2">
                        <input
                            type="text"
                            placeholder="Degree"
                            value={addItem.qualifications.degree || ''}
                            onChange={e => onAddChange('qualifications', 'degree', e.target.value)}
                            className="px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-purple-500"
                        />
                        <input
                            type="text"
                            placeholder="Institution"
                            value={addItem.qualifications.institution || ''}
                            onChange={e => onAddChange('qualifications', 'institution', e.target.value)}
                            className="px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-purple-500"
                        />
                        <input
                            type="number"
                            placeholder="Year"
                            value={addItem.qualifications.year || ''}
                            onChange={e => onAddChange('qualifications', 'year', parseInt(e.target.value))}
                            className="px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-purple-500"
                        />
                        <Button
                            type="button"
                            variant="primary"
                            onClick={onAddQualification}
                            loading={loading}
                        >
                            Add
                        </Button>
                        <Button
                            type="button"
                            variant="secondary"
                            onClick={() => onCancelAdd('qualifications')}
                            loading={loading}
                        >
                            Cancel
                        </Button>
                    </div>
                ) : (
                    <Button
                        type="button"
                        variant="primary"
                        onClick={() => setAddItem({ ...addItem, qualifications: { degree: '', institution: '', year: '' } })}
                    >
                        Add Qualification
                    </Button>
                )}
            </div>
            {qualifications.length === 0 && <div className="text-gray-500">No qualifications added.</div>}
            {qualifications.map((qual, idx) => (
                <div key={qual.id || idx} className="border border-gray-200 rounded-lg p-4 mb-3 flex items-center justify-between">
                    {editIndex.qualifications === idx ? (
                        <div className="flex gap-2 flex-wrap w-full">
                            <input
                                type="text"
                                placeholder="Degree"
                                value={editItem.qualifications.degree || ''}
                                onChange={e => onEditChange('qualifications', 'degree', e.target.value)}
                                className="px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-purple-500"
                            />
                            <input
                                type="text"
                                placeholder="Institution"
                                value={editItem.qualifications.institution || ''}
                                onChange={e => onEditChange('qualifications', 'institution', e.target.value)}
                                className="px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-purple-500"
                            />
                            <input
                                type="number"
                                placeholder="Year"
                                value={editItem.qualifications.year || ''}
                                onChange={e => onEditChange('qualifications', 'year', parseInt(e.target.value))}
                                className="px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-purple-500"
                            />
                            <Button
                                type="button"
                                variant="primary"
                                onClick={() => onUpdateQualification(idx)}
                                loading={loading}
                            >
                                Save
                            </Button>
                            <Button
                                type="button"
                                variant="secondary"
                                onClick={() => onCancelEdit('qualifications')}
                                loading={loading}
                            >
                                Cancel
                            </Button>
                        </div>
                    ) : (
                        <>
                            <div className="flex-1 flex gap-4 items-center">
                                <span className="font-medium">{qual.degree}</span>
                                <span className="text-gray-600">{qual.institution}</span>
                                <span className="text-gray-500">{qual.year}</span>
                            </div>
                            <div className="flex gap-2">
                                <Button
                                    type="button"
                                    variant="secondary"
                                    onClick={() => onEdit('qualifications', idx)}
                                    loading={loading}
                                >
                                    Edit
                                </Button>
                                <Button
                                    type="button"
                                    variant="danger"
                                    onClick={() => onDeleteQualification(idx)}
                                    loading={loading}
                                >
                                    Delete
                                </Button>
                            </div>
                        </>
                    )}
                </div>
            ))}
        </div>
    );
};

export default QualificationsTab; 